"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemReplacementData = exports.preconfiguredFrames = exports.defaultFasteners = exports.recommendedFasteners = exports.catalogState = exports.bom = void 0;
const reducer_1 = __importDefault(require("./bom/reducer"));
exports.bom = reducer_1.default;
const reducer_2 = __importDefault(require("./catalog/reducer"));
exports.catalogState = reducer_2.default;
const reducer_3 = __importDefault(require("./recommendedFasteners/reducer"));
exports.recommendedFasteners = reducer_3.default;
const reducer_4 = __importDefault(require("./defaultFasteners/reducer"));
exports.defaultFasteners = reducer_4.default;
const reducer_5 = __importDefault(require("./preconfiguredFrames/reducer"));
exports.preconfiguredFrames = reducer_5.default;
const reducer_6 = __importDefault(require("./itemReplacement/reducer"));
exports.itemReplacementData = reducer_6.default;
